// src/pages/CustomerHistory.jsx
import { useParams, Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import API from '../api';
import { formatTimestamp } from '../utils/timestamp-formatter';


export default function CustomerHistory() {
  const { customerId } = useParams();
  const [history, setHistory] = useState([]);

  useEffect(() => {
    API.get(`/customers/${customerId}/history`)
      .then(res => setHistory(res.data))
      .catch(err => {
        console.error(err);
        alert("Failed to load change history.");
      });
  }, [customerId]);

  // const formatDate = (dateString) => {
  //   const date = new Date(dateString);
  //   return isNaN(date.getTime()) ? 'Invalid Date' : date.toLocaleString();
  // };

  return (
    <div className="p-6 max-w-4xl mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4 text-blue-700">
        Change History for{' '}
        <span className="text-indigo-800 font-semibold italic">
          {history[0]?.company_name || `Customer #${customerId}`}
        </span>
      </h2>


      <table className="w-full text-sm border border-gray-300 mt-4 rounded-lg overflow-hidden border-collapse">
        <thead className="bg-blue-100 text-left">
          <tr>
            <th className="p-2 border border-gray-300">Timestamp</th>
            <th className="p-2 border border-gray-300">Field</th>
            <th className="p-2 border border-gray-300">Old Value</th>
            <th className="p-2 border border-gray-300">New Value</th>
            <th className="p-2 border border-gray-300">Changed By</th>
          </tr>
        </thead>
        <tbody>
          {history.map((h, i) => (
            <tr key={i} className="border-b border-gray-300 hover:bg-gray-50">
              <td className="p-2 border border-gray-300">{formatTimestamp(h.changed_at)}</td>
              <td className="p-2 border border-gray-300">{h.field_name}</td>
              <td className="p-2 border border-gray-300 text-gray-500">{h.old_value}</td>
              <td className="p-2 border border-gray-300 text-green-800 font-medium">{h.new_value}</td>
              <td className="p-2 border border-gray-300">{h.name} {h.last_name}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Back Button Positioned Bottom-Right */}
      <div className="mt-[10px] text-right">
        <Link
          to="/dashboard"
          className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold px-4 py-2 rounded-lg shadow transition"
        >
          <span className="text-lg">←</span> Back to Dashboard
        </Link>
      </div>
    </div>
  );
}
